import clsx from 'clsx'
import Image from 'next/image'

interface MainButtonProps {
  label: string
  onClick?: () => void
  icon?: string
  className?: string
  href?: string
  target?: '_blank' | '_self'
  disabled?: boolean
  noBorder?: boolean
}

const MainButton = ({
  label,
  onClick,
  icon,
  className = '',
  href,
  target = '_self',
  disabled = false,
  noBorder = false,
}: MainButtonProps) => {
  const buttonContent = (
    <div
      className={clsx(
        'flex items-center gap-2.5 rounded-full px-5 pr-2 py-2 cursor-pointer',
        !noBorder && 'border border-[#10F48B]',
        icon ? 'pr-2' : 'pr-5',
      )}
    >
      {/* Text */}
      <span
        className={clsx(
          'text-sm font-black uppercase leading-[150%] text-white',
          disabled && 'opacity-50',
        )}
          style={{
        textWrapMode:"nowrap"
      }}
      >
        {label}
      </span>

      {/* Icon Circle */}
      {icon && (
        <div className="flex h-6 w-6 lg:h-8 lg:w-8 items-center justify-center rounded-full bg-[#10F48B]">
          <Image
            src={icon}
            alt="button icon"
            width={32}
            height={32}
            className="h-6 w-6 lg:h-8 lg:w-8"
          />
        </div>
      )}
    </div>
  )

  if (href) {
    return (
      <a
        href={href}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        className={clsx(
          'inline-block w-fit overflow-hidden rounded-full transition-transform hover:scale-105 active:scale-95',
          disabled && 'pointer-events-none opacity-50',
          className,
        )}
      >
        {buttonContent}
      </a>
    )
  }

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        'w-fit overflow-hidden rounded-full transition-transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:hover:scale-100',
        className,
      )}
    
    >
      {buttonContent}
    </button>
  )
}

export default MainButton
